<template>
  <v-app>

    <v-navigation-drawer
        fixed
        :clipped="$vuetify.breakpoint.mdAndUp"
        app
        v-model="drawer"
    >
      <v-list dense>
        <template v-for="(item, index) in items">
          <v-layout row v-if="item.heading" align-center :key="item.heading">
            <v-flex xs6>
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <a href="#!" class="body-2 black--text">EDIT</a>
            </v-flex>
          </v-layout>
          <v-list-group
              v-else-if="item.children"
              v-model="item.model"
              :key="item.text"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>{{ item.text }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
                :to="child.to"
                v-for="(child, i) in item.children"
                :key="i"
            >
              <v-list-tile-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  <v-list-tile-title>{{ child.text }}</v-list-tile-title>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list-group>
          <v-list-tile v-else :to="item.to" :key="index">
            <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-progress-linear
        v-if="this.$store.state.progress"
        color="deep-purple"
        indeterminate
        height="6"
        style="position: fixed; top: 50px; z-index: 99999"
    ></v-progress-linear>
    <v-toolbar
        color="amber"
        app
        :clipped-left="$vuetify.breakpoint.mdAndUp"
        fixed
    >
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <v-toolbar-side-icon
            @click.stop="drawer = !drawer"
        ></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">{{ currentUser.firstName }}</span>
      </v-toolbar-title>

      <!-- Tenant/Marketplace Selector'ı toolbar'da ekle -->
      <div style="display: flex; gap: 10px; margin-left: 20px; margin-right: 20px;" v-if="currentUser && currentUser.tenantOptions">
        <v-select
            v-model="selectedTenant"
            :items="tenantOptions"
            item-text="tenantName"
            item-value="tenantId"
            label="Ürün"
            @change="onTenantChange"
            outlined
            dense
            hide-details
            style="min-width: 150px; margin-top: 8px;"
        ></v-select>
        <v-select
            v-model="selectedMarketplace"
            :items="filteredMarketplaceOptions"
            item-text="mpName"
            item-value="mpId"
            label="MarketPlace"
            @change="onMarketplaceChange"
            outlined
            dense
            hide-details
            style="min-width: 150px; margin-top: 8px;"
            :disabled="!selectedTenant"
        ></v-select>
      </div>

      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon>apps</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon>notifications</v-icon>
      </v-btn>
      <v-btn icon large @click="logout">
        <v-avatar size="32px" tile>
          <img src="@/assets/logo.svg" alt="Vuetify" />
        </v-avatar>
      </v-btn>

    </v-toolbar>

    <v-content>
      <router-view />
    </v-content>
    <v-dialog v-model="$store.state.dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Bilgilendirme</v-card-title>
        <v-card-text>{{ $store.state.message }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
              color="success"
              dark
              depressed
              @click="$store.state.dialog = false"
          >Tamam</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>
<script>
import { authenticationService } from "@/_services";

export default {
  data() {
    return {
      currentUser: null,
      message: null,
      drawer: null,
      selectedTenant: null,
      selectedMarketplace: null,
      tenantOptions: [],
      marketplaceOptions: [],
      allTenantMarketplaces: [], // Tüm tenant-marketplace kombinasyonları
      
    };
  },
  props: {
    source: String,
  },
  computed: {
    isAdmin() {
      return this.currentUser && this.currentUser.isAdmin;
    },
    filteredMarketplaceOptions() {
      if (!this.selectedTenant || !this.allTenantMarketplaces) {
        return [];
      }

      // Seçili tenant'a ait marketplace'leri filtrele
      return this.allTenantMarketplaces
          .filter(item => item.tenantId === this.selectedTenant)
          .map(item => ({ mpId: item.mpId, mpName: item.mpName }))
          .filter((item, index, self) =>
              index === self.findIndex(t => t.mpId === item.mpId)
          ); // Unique marketplace'ler
    },
    items() {
          return [
            { icon: "contacts", text: "Dashboard", to: "/productx" },
            { icon: "contacts", text: "Rapor", to: "/report" },
            // Sipariş menu with conditional submenu
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Sipariş",
              model: false,
              children: [
                { text: "Siparişler", to: "/order" },
                ...(this.selectedTenant === 2 ? [{ text: "Genişletilmiş Sipariş", to: "/rich-order" }] : [])
              ]
            },
            { icon: "history", text: "Stok", to: "/stock" },
            { icon: "contacts", text: "Ödemeler", to: "/payment" },
            { icon: "compare_arrows", text: "Mutabakat", to: "/reconciliation" },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Ürün",
              model: true,
              children: [
                { icon: "add", text: "MP Ürün Listele", to: "/mpproduct" },
                { icon: "add", text: "MP Ürün Ekle", to: "/mpproduct/detail" },
                { icon: "add", text: "Stok Grup Listele ", to: "/stockGroup" },
                { icon: "add", text: "Stok Grup Ekle", to: "/stockGroup/detail" },
                { icon: "add", text: "Çarpan Listele", to: "/formulaMultiplier" },
                { icon: "add", text: "Çarpan Ekle", to: "/formulaMultiplier/detail" },
              ],
            },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Excel",
              model: true,
              children: [
                { icon: "add", text: "Excel Listele", to: "/poolOrder" },
              ],
            },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "İndirim",
              model: true,
              children: [
                { icon: "add", text: "MP İndirim Listele", to: "/mpdiscount" },
                { icon: "add", text: "MP İndirim Ekle", to: "/mpdiscount/detail" },
              ],
            },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Döviz",
              model: true,
              children: [
                { icon: "add", text: "Döviz listele", to: "/priceIncrease" },
                { icon: "add", text: "Döviz Ekle", to: "/priceIncrease/detail" },
              ],
            },
            {
              icon: "keyboard_arrow_up",
              "icon-alt": "keyboard_arrow_down",
              text: "Sigorta",
              model: true,
              children: [
                { icon: "add", text: "Sigorta listele", to: "/insurance" },
                { icon: "add", text: "Sigorta Ekle", to: "/insurance/detail" },
              ],
            },
            { icon: "settings", text: "Ayarlar", to: "/setting" },
          ];

    }
  },
  created() {
    authenticationService.currentUser.subscribe(
        (x) => {
          this.currentUser = x || {};
          this.initializeSelectors();
        }
    );
  },
  methods: {
    logout() {
      authenticationService.logout();
      this.$router.push("/login");
    },
    initializeSelectors() {
      if (this.currentUser) {
        this.tenantOptions = this.currentUser.tenantOptions || [];
        this.marketplaceOptions = this.currentUser.marketplaceOptions || [];
        this.allTenantMarketplaces = this.currentUser.allTenantMarketplaces || [];

        // Seçili değerleri localStorage'dan al veya varsayılan değerleri ayarla
        const savedTenant = localStorage.getItem('selectedTenantId');
        const savedMp = localStorage.getItem('selectedMpId');

        this.selectedTenant = savedTenant ? parseInt(savedTenant) : this.currentUser.tenantId;

        // Marketplace'i tenant değişikliğinden sonra ayarla
        this.$nextTick(() => {
          this.selectedMarketplace = savedMp ? parseInt(savedMp) : this.currentUser.mpId;
        });

        // İlk yüklemede localStorage'a kaydet
        if (!savedTenant && this.selectedTenant) {
          localStorage.setItem('selectedTenantId', this.selectedTenant.toString());
        }
        if (!savedMp && this.selectedMarketplace) {
          localStorage.setItem('selectedMpId', this.selectedMarketplace.toString());
        }
      }
    },
    onTenantChange() {
      if (this.selectedTenant) {
        localStorage.setItem('selectedTenantId', this.selectedTenant.toString());

        // Marketplace seçimini sıfırla
        this.selectedMarketplace = null;
        localStorage.removeItem('selectedMpId');

        // İlk marketplace'i otomatik seç (opsiyonel)
        this.$nextTick(() => {
          if (this.filteredMarketplaceOptions.length > 0) {
            this.selectedMarketplace = this.filteredMarketplaceOptions[0].mpId;
            this.onMarketplaceChange();
          }
        });

        // Sayfa yenileme (isteğe bağlı)
        window.location.reload();
      }
    },
    onMarketplaceChange() {
      if (this.selectedMarketplace) {
        localStorage.setItem('selectedMpId', this.selectedMarketplace.toString());
        
        setTimeout(()=>{
          window.location.reload();
        },100)
      }
    }
  }
};
</script>